import Vue from "vue";

import DigitalPurchases from "./DigitalPurchases.vue";

export function load() {
    const selector = "my-digital-puchases";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(DigitalPurchases, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
